import React from 'react'
import HomeBlog from '../home/HomeBlog'
import { Link } from "react-router-dom";

const Blog = () => {
    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Our Blog</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active" style={{ color: "red" }}>Our Blog</li>
                    </ul>
                </div>
            </div>
            <HomeBlog />


        </>
    )
}

export default Blog